import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-sun-line text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-xl font-bold text-background-50">
                  向日葵视频
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                向日葵视频是国内领先的数字视频在线观看平台，提供91视频、97视频、51视频、久久视频等高清数字视频大全，致力于为用户打造极致的免费观影体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/91-video" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    91视频高清在线
                  </Link>
                </li>
                <li>
                  <Link to="/category/97-video" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    97视频免费观看
                  </Link>
                </li>
                <li>
                  <Link to="/category/51-video" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    51视频在线播放
                  </Link>
                </li>
                <li>
                  <Link to="/category/jiujiu-video" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    久久视频高清资源
                  </Link>
                </li>
                <li>
                  <Link to="/category/digital-video" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    数字视频大全
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                  <span>北京市朝阳区建国路88号SOHO现代城A座15层</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-6688</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-primary-400"></i>
                  <a href="mailto:contact@xiangrikuishipin.com" className="hover:text-primary-400 transition-colors">
                    contact@xiangrikuishipin.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-700">
          <p className="text-center text-sm text-foreground-500">
            &copy; {currentYear} 向日葵视频 xiangrikuishipin.com - 数字视频大全 | 91视频、97视频、51视频、久久视频免费在线观看平台。本站内容仅供学习交流。
          </p>
        </div>
      </div>
    </footer>
  );
}